module.exports = __webpack_public_path__ + "static/media/01.1ea198c4.jpg";